import {getUserInfo} from "api/commonUtil"
import BranchList from "./branch/BranchList";
import ProductList from "./product/ProductList";
import UserList from "./user/UserList";
import BranchProductList from "./product/BranchProductList";
import OrderListByCond from "./order/OrderListByCond";
import ProductOrderList from "./order/ProductOrderList";
import QuickCommerceSettle from "./settle/QuickCommerceSettle";
import OrderSchedResult from "./scheduler/OrderSchedResult";
import OrderSchedForce from "./scheduler/OrderSchedForce";

export const URL = {
	MAIN: "/",
	LOGIN: "/login",
	ERROR: "/error",
	TEST: "/test",
	// MyInfo: "/MyInfo",
}


const menu = [
	//////////////////////////////////////////////////////////////////
	// 지점관리 ///////////////////////////////////////////////////////
	//////////////////////////////////////////////////////////////////
	{
		menuId: "branchMgmt",
		label: "지점 관리",
		// targetSubMenuId: "pendingBox",	// 대메뉴 선택 시 기본은 첫번째 submenu. 다른 특정 메뉴를 원할때 설정
		auth: ["HEADOFFICE"],
		subMenus: [
			{
				menuId: "branch",
				auth: ["HEADOFFICE"],
				label: "지점",
				menuUrl: "/branchList",
				component: <BranchList />
			},
			// {
			// 	menuId: "branchHoliday",
			// 	auth: ["BRANCH"],
			// 	label: "휴일",
			// 	menuUrl: "/branchHoliday",
			// 	component: <BranchList />
			// },
		]
	},
	//////////////////////////////////////////////////////////////////
	// 상품관리 ///////////////////////////////////////////////////////
	//////////////////////////////////////////////////////////////////
	{
		menuId: "productMgmt",
		label: "상품 관리",
		// targetSubMenuId: "pendingBox",	// 대메뉴 선택 시 기본은 첫번째 submenu. 다른 특정 메뉴를 원할때 설정
		auth: ["HEADOFFICE"],
		subMenus: [
			{
				menuId: "product",
				auth: ["HEADOFFICE"],
				label: "상품",
				menuUrl: "/productList",
				component: <ProductList />
			},
			{
				menuId: "branchProduct",
				auth: ["HEADOFFICE", "BRANCH"],
				label: "재고",
				menuUrl: "/branchProductList",
				component: <BranchProductList />
			},
		]
	},
	//////////////////////////////////////////////////////////////////
	// 주문관리 ///////////////////////////////////////////////////////
	//////////////////////////////////////////////////////////////////
	{
		menuId: "orderMgmt",
		label: "주문 관리",
		// targetSubMenuId: "pendingBox",	// 대메뉴 선택 시 기본은 첫번째 submenu. 다른 특정 메뉴를 원할때 설정
		auth: ["HEADOFFICE"],
		subMenus: [
			{
				menuId: "orderList",
				auth: ["ALL"],
				label: "주문 조회",
				menuUrl: "/orderList",
				component: <ProductOrderList />
			},
			{
				menuId: "orderListByCond",
				auth: ["HEADOFFICE"],
				label: "조건형 주문 조회",
				menuUrl: "/orderListByCond",
				component: <OrderListByCond />
			},
			{
				menuId: "orderSchedResult",
				auth: ["HEADOFFICE"],
				label: "주문조회 배치 결과",
				menuUrl: "/orderSchedResult",
				component: <OrderSchedResult />
			},
			{
				menuId: "orderSchedForce",
				auth: ["HEADOFFICE"],
				label: "주문조회 수동 배치",
				menuUrl: "/orderSchedForce",
				component: <OrderSchedForce />
			},
		]
	},
	//////////////////////////////////////////////////////////////////
	// 정산 ///////////////////////////////////////////////////////
	//////////////////////////////////////////////////////////////////
	{
		menuId: "settlement",
		label: "정산",
		// targetSubMenuId: "pendingBox",	// 대메뉴 선택 시 기본은 첫번째 submenu. 다른 특정 메뉴를 원할때 설정
		auth: ["HEADOFFICE"],
		subMenus: [
			{
				menuId: "quickCommerceSettle",
				auth: ["HEADOFFICE"],
				label: "퀵커머스정산조회",
				menuUrl: "/quickCommerceSettle",
				component: <QuickCommerceSettle />
			},
		]
	},
	//////////////////////////////////////////////////////////////////
	// 사용자관리 ///////////////////////////////////////////////////////
	//////////////////////////////////////////////////////////////////
	{
		menuId: "userMgmt",
		label: "사용자 관리",
		auth: ["HEADOFFICE"],
		subMenus: [
			{
				menuId: "userMgmt",
				label: "사용자",
				menuUrl: "/userList",
				component: <UserList />
			},
		]
	},
];

/**
 * 전체 메뉴를 Parent-child 관계없이 Flat하게 변경해서 반환
 */
export const getFlatMenu = (menus, pId) => {
	if(!menus) menus = menu;
	const result = [];

	// component가 있는 애들을 subMenus를 제외하고 담기. 대메뉴 Label도 담아준다. 그래야 좌측메뉴가 정상적으로 표시됨.
	result.push(...menus.filter(menu => menu.hasOwnProperty("component")).map(menu => {
		// return {id: menu.id, label: menu.label, component: menu.component, pLabel: pLabel}
		// const menuInfo  = {menuId: menu.menuId, label: menu.label, menuUrl: menu.menuUrl, component: menu.component, pId: pId};
		const menuInfo  = {...menu, pId: pId};
		if(menu.tabAuth) menuInfo.tabAuth = menu.tabAuth;
		return menuInfo;
	}));
	menus.filter(menu => menu.hasOwnProperty("subMenus")).forEach(menu => {
		result.push(...getFlatMenu(menu.subMenus, pId ?? menu.menuId));
	})

	return result;
}

/**
 * 메뉴 목록 조회
 * @param {String} pId 하위 메뉴 조회시 부모 id
 * @returns 
 */
export const getMenuList = (pId) => {
	// const role = JSON.parse(sessionStorage.getItem("loginUser"))?.authorCode;
	let menus = JSON.parse(JSON.stringify(menu));
	const userInfo = getUserInfo();
	const role = userInfo?.userType;
	if(role === undefined) return [];

	const result = [];

	if(!pId) {	// 대메뉴
		menus.forEach(m => {
			if(hasAuth(role, m)) {
				if(m.hasOwnProperty("targetSubMenuId")) {
					// 대메뉴 클릭 시 정해진 메뉴가 있는 경우
					// 대상 메뉴가 URL과 Component가 있어야 함. -> 최하단 메뉴
					// Component가 없으면 getFlatMenu()에서 걸러짐.
					// URL이 없으면 여기서 걸러짐.
					const targetUrl = getFlatMenu().find(fm => fm.menuId === m.targetSubMenuId)?.menuUrl;
					if(targetUrl) {
						m.menuUrl = targetUrl;
					}
				}
				if(!m.hasOwnProperty("menuUrl") && m.hasOwnProperty("subMenus")) {
					// 메뉴에 URL이 없고, subMenus가 있으면 권한 있는 첫번째 subMenu의 URL로 세팅
					m.menuUrl = getFirstSubMenuUrl(role, m);
				}
				result.push(m);
			}
		})
	} else {	// Left 메뉴
		// const topMenu = menu.filter(m => m.label === pLabel)[0];
		// const topMenu = menu.find(m => m.id === pId);
		const topMenu = menus.find(m => m.menuId === pId);
		const topMenuAuth = topMenu.auth.includes("ALL") || topMenu.auth.includes(role);
		const filteredSubMenus = removeNoAuth(role, topMenu.subMenus, topMenuAuth);	// 권한 없는 하위 메뉴들을 제거
		result.push(...filteredSubMenus);
	}
	return result;
}

const getFirstSubMenuUrl = (role, menu, topMenuAuth) => {
	if(menu.hasOwnProperty("menuUrl") && menu.menuUrl !== "") return menu.menuUrl;

	if(topMenuAuth == null) topMenuAuth = menu.auth.includes("ALL") || menu.auth.includes(role);

	const filteredSubMenus = removeNoAuth(role, menu.subMenus, topMenuAuth);	// 권한 없는 하위 메뉴들을 제거
	for(let i=0; i<filteredSubMenus.length; i++) {
		let subM = filteredSubMenus[i];
		if(subM.hasOwnProperty("menuUrl") && subM.menuUrl !== "") {
			return subM.menuUrl;
		}
		if(!subM.hasOwnProperty("menuUrl") && subM.hasOwnProperty("subMenus")) {
			return getFirstSubMenuUrl(role, subM, topMenuAuth);
		}
	}
}

/**
 * 권한 없는 메뉴들 목록에서 제거
 * @param {*} role 
 * @param {*} orgMenu 
 * @param {*} defaultAuth 
 * @returns 
 */
const removeNoAuth = (role, orgMenu, defaultAuth = false) => {
	// let menus = orgMenu.slice();
	let menus = JSON.parse(JSON.stringify(orgMenu));

	menus = menus.filter(m => hasAuth(role, m, defaultAuth));	// 권한 없는애들 없애기
	// 하위 메뉴가 있는 애들만 뽑아서 하위 메뉴도 권한 체크
	// const hasSub = menus.filter(m => m.hasOwnProperty("subMenus") && m.subMenus.length > 0);
	menus.forEach(menu => {
		if(menu.hasOwnProperty("subMenus") && menu.subMenus.length > 0) {
			let pAuth = defaultAuth;
			if(menu.hasOwnProperty("auth")) {	// auth 항목이 있을때
				if(menu.auth.includes("ALL") || menu.auth.includes(role)) {
					pAuth = true;
				} else {
					pAuth = false;
				}
			}
			menu.subMenus = removeNoAuth(role, menu.subMenus, pAuth);
		}

	});
	return menus;
}

/**
 * 메뉴에 권한이 있는지 확인
 * 하위 메뉴에 권한이 있으면 하위메뉴의 권한이 우선.
 * 하위 메뉴에 권한이 없으면 부모의 권한을 사용.
 * @param {*} role 
 * @param {*} menu 
 * @param {*} defaultAuth 
 * @returns 
 */
const hasAuth = (role, menu, defaultAuth = false) => {
	if(role === "SYSADMIN") return true;	// 시스템 관리자는 전체 권한.

	if(menu.hasOwnProperty("auth")) {	// auth 항목이 있을때
		if(menu.auth.includes("ALL") || menu.auth.includes(role)) {
			defaultAuth = true;
		} else {
			defaultAuth = false;
		}
	}

	if(menu.hasOwnProperty("subMenus")) {
		// 하위메뉴가 우선권.
		// 하위메뉴에 권한이 있으면 권한이 있는 것으로 간주.
		const subResult = menu.subMenus.some(m => hasAuth(role, m, defaultAuth));
		if(subResult) return true;
	}

	return defaultAuth;
}

export const getParentMenuIdByUri = (uri) => {
	let result = [];
	const menus = menu;
	for(let i=0; i<menus.length; i++) {
		let m = menus[i];
		result = [m.menuId];
		if(m.menuUrl === uri) return result;
		if(m.hasOwnProperty("subMenus")) {
			for(let j=0; j<m.subMenus.length; j++) {
				let m2 = m.subMenus[j];
				result = result.slice(0, 1);
				result[1] = m2.menuId;
				if(m2.menuUrl === uri) return result;
				if(m2.hasOwnProperty("subMenus")) {
					for(let k=0; k<m2.subMenus.length; k++) {
						let m3 = m2.subMenus[k];
						result = result.slice(0, 2);
						result[2] = m3.menuId;
						if(m3.menuUrl === uri) return result;
					}
				}

			}
		}
	}

	return [];
}

// 최상위 메뉴부터 uri의 메뉴까지 array로 반환
export const getMenuHierarchyByUri = (uri) => {
	let result = [];
	const menus = [...menu];
	for(let i=0; i<menus.length; i++) {
		let m = menus[i];
		result = [m];
		if(m.menuUrl === uri) return result;
		if(m.hasOwnProperty("subMenus")) {
			for(let j=0; j<m.subMenus.length; j++) {
				let m2 = m.subMenus[j];
				result = result.slice(0, 1);
				result[1] = m2;
				if(m2.menuUrl === uri) return result;
				if(m2.hasOwnProperty("subMenus")) {
					for(let k=0; k<m2.subMenus.length; k++) {
						let m3 = m2.subMenus[k];
						result = result.slice(0, 2);
						result[2] = m3;
						if(m3.menuUrl === uri) return result;
					}
				}

			}
		}
	}

	return [];
}

export const getShortCutMenu = () => {
	if(getUserInfo() == null) return [];
	const pMenuList = getMenuList();	// 권한 있는 1depth 메뉴 조회
	const sMenuList = pMenuList.map(p => getMenuList(p.menuId)).reduce((acc, d) => acc.concat(d));	// 1depth의 권한 있는 하위 메뉴 조회
	const flatMenuList = getFlatMenu(sMenuList);	// 권한 있는 하위 메뉴를 flat하게
	const shortCutMenu = flatMenuList.filter(m => m.mainShortCut);	// 그중에 mainShortCut이 true인 것만
	return shortCutMenu;
}

const menuItems = getFlatMenu();	// flat 메뉴 저장
export function getDocumentTitleByPath(pathName) {
	const menuItem = menuItems.find(m => m.menuUrl === pathName);
	const title = menuItem ? menuItem.title ?? menuItem.label : "";
	return getDocumentTitle(title);
}
export function getDocumentTitle(label) {
	let returnLabel = "";
	if(process.env.NODE_ENV === "development") {
		if(document.location.hostname === "192.168.0.120") returnLabel = "[개발]" + label;
		else if(document.location.hostname === "localhost") returnLabel = "[로컬]" + label;
		else returnLabel = label;
	} else {
		returnLabel = label;
	}
	if(label === null || label === "") {
		return returnLabel + "SFF NQC System";
	}
	return returnLabel + " -SFF";
}